export default __webpack_public_path__ + "images/77362f1e6716c67495f4ff9ff8c0cbbb.png";